<template>
  <b-card class="row-height">
    <b-row class="col-md-12">
      <b-col>
        <h3 class="font-weight-bolder">
          <b-link class="btn btn-outline-primary" to="/invoices">
            <FeatherIcon icon="ChevronLeftIcon"></FeatherIcon>
            {{ $t("back") }}
          </b-link>
          <p style="margin-top: 15px" v-if="taskStatus == 0">
            {{ $t("start_selling_your_initial_invoices") }}
          </p>
        </h3>
      </b-col>
    </b-row>

    <b-col md="12" class="mt-2">
      <label class="font-weight-bolder">{{ $t("issuer") }}</label>
      <b-form-input class="col-md-5" :value="myComp ? myComp.name : '/'" disabled></b-form-input>
    </b-col>
    <b-col md="12" class="mt-2">
      <b-form-file style="display: none" @change="uploadFile($event, file1)" v-model.trim="file1"
        :placeholder="$t('upload_files_here')" drop-placeholder="Drop file here..."
        ref="fileInput1"></b-form-file>

      <div class="mt-1 mr-0 pr-0">
        <b-alert show variant="info" class="col-md-6">
          <b-row class="col-md-12">
            <b-col class="col-md-12 mt-2 mb-2 text-center pointer" @click="triggerFileInput">
              <div>
                <feather-icon icon="DownloadIcon" size="25" />
                <span></span>
                {{ $t("upload_invoice_here") }}
              </div>
            </b-col>
          </b-row>
        </b-alert>
      </div>
    </b-col>

    <b-row md="12">
      <validation-observer class="col-md-12" ref="uploadInvoices" v-model.trim="valid">
        <b-col v-for="(item, index) in uploadedInvoices" md="12" :key="index">
          <div class="border-blue-left mt-3 mb-1 ml-1">
            <h4 class="pl-1 col-md-12">
              <span class="light-blue">{{ $t("Invoice") }} {{ index + 1 }} :</span>
              {{ item ? item.title : "" }}
            </h4>
          </div>

          <b-form>
            <div class="col-md-12">
              <b-row m-0 p-0 v-if="!load">
                <b-col sm="12" xl="12" md="12" lg="12" class="mt-2">
                  <b-form-group v-slot="{ ariaDescribedby }" class="d-flex" :id="$t('recourse') + ' ' + index">
                    <validation-provider #default="{ errors }" :name="$t('recourse')" rules="required">
                      <div class="d-flex">
                        <b-form-radio @change="changeRecourse(item, index, 0)" v-b-tooltip.hover
                          :title="$t(recourseOptions[0].title)" :id="'non-recourse' + index" v-model="item.recourse"
                          :aria-describedby="ariaDescribedby" name="Non-recourse" value="0" class="mr-2">
                          {{ $t('Non-recourse') }}
                        </b-form-radio>
                        <b-form-radio @change="changeRecourse(item, index, 1)" v-b-tooltip.hover v-model="item.recourse"
                          :title="$t(recourseOptions[1].title)" :aria-describedby="ariaDescribedby" name="Recourse"
                          value="1" class="mr-2" :id="'recourse' + index"> {{
                            $t('Recourse')
                          }}
                          <small>{{ $t('recourse_text') }}</small>
                        </b-form-radio>
                        <b-form-radio @change="changeRecourse(item, index, 2)" v-b-tooltip.hover v-model="item.recourse"
                          :title="$t(recourseOptions[2].title)" :aria-describedby="ariaDescribedby" name="Reverse"
                          value="2" class="mr-2" :id="'reverse' + index"> {{ $t('Reverse') }}
                        </b-form-radio>
                      </div>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col sm="12" xl="8" md="8" lg="8">
                  <b-form-group id="deptor" :label="(item.recourse == 2 ? $t('supplier') : $t('deptor')) + ':'"
                    label-for="deptor" class="font-weight-bolder">
                    <validation-provider #default="{ errors }"
                      :name="(item.recourse == 2 ? $t('supplier') : $t('deptor')) + ' ' + index" rules="required">
                      <vue-autosuggest :suggestions="filteredOptions" :limit="10" v-model.trim="item.company_name"
                        :input-props="{
                          id: 'autosuggest__input',
                          class: 'form-control',
                        }" @selected="onSelected($event, item, index)" @keyup="searchForCompaniesName(item)">
                        <template slot-scope="{ suggestion }">
                          <span class="my-suggestion-item">{{ suggestion.item }}
                          </span>
                        </template>
                      </vue-autosuggest>
                      <b-button variant="primary" v-if="showHint" class="mt-1" disabled>
                        <b-spinner small type="grow"></b-spinner>
                        {{ $t("loading") }}...
                      </b-button>

                      <div class="alert alert-secondary p-1 mt-1" v-if="companyMessage">
                        <span v-if="$store.state.app.language == 'en'">
                          Please enter the company name in this field exactly as it appears in the official commercial register. If you still cannot find the company of your
                          {{ item.is_reverse == 1 ? 'supplier' : 'debtor' }} on the list, please contact the administrator at
                          <a href="mailto:support@aequitex.com" class="font-weight-bolder">support@aequitex.com</a>
                          or <a @click="openLink()" class="font-weight-bolder" style="text-decoration:underline;">book a meeting here.</a></span>

                        <span v-else-if="$store.state.app.language == 'de'">
                          Bitte geben Sie den Firmennamen in diesem Feld genau so ein, wie er im offiziellen Handelsregister hinterlegt wurde. Falls Sie das Unternehmen Ihres
                          {{ item.is_reverse == 1 ? 'Anbieter' : 'Schuldners' }} oder Zulieferers dann immer noch nicht in der Liste finden können, wenden Sie sich bitte an den Administrator unter
                          <a href="mailto:support@aequitex.com" class="font-weight-bolder">support@aequitex.com</a>
                          oder vereinbaren Sie <a @click="openLink()" class="font-weight-bolder" style="text-decoration:underline;">hier</a> einen Termin.
                         </span>
                      </div>

                      <small class="text-danger">{{ $t(errors[0]) }}</small>
                    </validation-provider>
                  </b-form-group>
                  <img v-if="loader" width="50" height="50" src="/new-loader.svg" />
                </b-col>

                <b-col sm="12" xl="4" md="4" lg="4">
                  <b-form-group id="currency" class="font-weight-bolder" :label="$t('currency') + ':'"
                    label-for="currency" clasa="d-flex flex-direction-column">
                    <b-dropdown id="currency-dropdown" variant="outline-dark" class="w-50 no-arrow">

                      <template #button-content>
                        <span v-if="currency_name">{{ currency_name }}</span>
                        <span v-else>{{ $t('select_currency') }}</span>
                      </template>

                      <b-dropdown-item v-for="option in currencies" :key="option.id" :value="option.id"
                        @click="changeCurrency(option.id, option.name)">
                        {{ option.name }}
                      </b-dropdown-item>

                    </b-dropdown>

                    <div>
                      <small class="text-danger" v-if="currencyError">{{ $t(currencyError) }}
                      </small>
                    </div>
                  </b-form-group>
                </b-col>

                <b-col sm="12" xl="6" md="6" lg="6">
                  <b-form-group id="amount" class="font-weight-bolder" :label="$t('invoice_amount') + ':'"
                    label-for="amount">
                    <validation-provider #default="{ errors }" :name="$t('invoice_amount') + ' ' + index"
                      rules="required">
                      <input @focusout="parsedAmount1($event, item.amount, index)"
                        :id="$t('invoice_amount') + ' ' + index" v-model.trim="item.amount" placeholder="00'000.00"
                        class="form-control" @input="item.amount = item.amount.replace(/[^\d.,]/g, '')" />

                      <small class="text-danger" v-if="numbersAmountError">{{
                        numbersAmountError
                        }}
                      </small>
                      <br v-if="numbersAmountError" />
                      <small class="text-danger">{{ $t(errors[0]) }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col sm="12" xl="6" md="6" lg="6">
                  <b-form-group id="issue_date" :label="$t('issue_date') + ':'" label-for="issue_date"
                    class="font-weight-bolder">
                    <validation-provider #default="{ errors }" :name="$t('issue_date') + ' ' + index" rules="required">
                      <b-form-datepicker :max="disabledDates" no-flip :id="$t('issue_date') + ' ' + index"
                        @input="changeTerms(item, index)" v-model.trim="item.issue_date"
                        :state="errors.length > 0 ? false : null" :disabled="disableInputs" required
                        :placeholder="$t('choose_a_date')" :locale="$store.state.app && $store.state.app.language == 'de'
                          ? 'de'
                          : 'en'
                          "></b-form-datepicker>
                      <small class="text-danger">{{ $t(errors[0]) }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col sm="3" xl="3" md="3" lg="3">
                  <b-form-group id="payment_date" class="font-weight-bolder">
                    <template #label>
                      {{ $t('payment_term_in_days')  + ' :' }}
                      <feather-icon v-b-tooltip.hover :title="$t('payment_terms_in_days_tooltip')" icon="HelpCircleIcon" size="18" />
                    </template>
                    <validation-provider #default="{ errors }"
                      :name="$t('payment_term_in_days') + ' ' + index + ' (' + $t('calculated') + ') :'"
                      rules="required">
                      <b-form-input :id="'payment_term_in_days_' + index" v-model.trim="item.terms" type="number"
                        max="90" disabled required></b-form-input>
                      <small class="text-danger">{{ $t(errors[0]) }}</small>
                      <small class="text-danger" v-if="errorDueDate.length > 0">{{ errorDueDate }}
                      </small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col sm="3" xl="3" md="3" lg="3">
                  <b-form-group id="due_days_calculated" class="font-weight-bolder">
                    <template #label>
                      {{ $t('due_days_calculated') +  ':' }}
                      <feather-icon v-b-tooltip.hover :title="$t('financing_due_days_tooltip')"  icon="HelpCircleIcon" size="18" />
                    </template>
                    <validation-provider #default="{ errors }"
                      :name="$t('due_days_calculated') + ' ' + index"
                      rules="required">
                      <b-form-input :id="'due_days_calculated_' + index" v-model.trim="item.due_days_calculated" type="number"
                        disabled required></b-form-input>
                      <small class="text-danger">{{ $t(errors[0]) }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col sm="12" xl="6" md="6" lg="6">
                  <b-form-group id="due_date" class="font-weight-bolder" :label="$t('due_date') + ':'"
                    label-for="due_date">
                    <validation-provider #default="{ errors }" name="due_date" rules="required">
                      <b-form-datepicker :min="disabledDueDates" no-flip :id="'due_date' + index"
                        v-model.trim="item.due_date" :disabled="disableInputs" @input="changeTerms(item, index)"
                        required :placeholder="$t('choose_a_date')"></b-form-datepicker>
                      <small class="text-danger">{{ $t(errors[0]) }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>

                <b-col cols="12" xl="6" md="6" lg="6">
                  <b-form-group class="font-weight-bolder" :label="$t('invoice_number') + ':'"
                    label-for="invoice_number">
                    <validation-provider #default="{ errors }" :name="$t('invoice_number') + ' ' + index"
                      rules="required">
                      <b-form-input :id="$t('invoice_number') + ' ' + index" v-model.trim="item.invoice_number"
                        :disabled="disableInputs" required></b-form-input>
                      <small class="text-danger">{{ $t(errors[0]) }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>

                <b-col sm="12" xl="6" md="6" lg="6">
                  <b-form-group class="font-weight-bolder" :label="$t('set_invoice_auto_remove_days')" label-for="auto_remove_days">
                    <validation-provider #default="{errors}" :name="$t('set_invoice_auto_remove_days')" rules="required">
                      <b-form-input
                          id="auto_remove_days"
                          v-model.number="autoRemoveTimeValue"
                          :placeholder="$t('set_invoice_auto_remove_days_placeholder')"
                          type="number"
                          min="1"
                          max="999"
                          @input="autoRemoveDaysError = ''"
                      />
                      <small class="text-danger" v-if="autoRemoveDaysError">{{ $t(autoRemoveDaysError) }}</small>
                    </validation-provider>
                  </b-form-group>
                  <small>
                    {{$t('set_invoice_auto_remove_days_desc_invoice_level')}}
                  </small>
                </b-col>

                <!-- Documents section extracted into dedicated component (full width) -->
                <b-col sm="12" xl="12" md="12" lg="12" class="mt-2">
                  <InvoiceDocuments
                    :invoice="item"
                    :index="index"
                    :documentRequestStatuses="documentRequestStatuses"
                    :nonRecourseAnnualFSMissing="nonRecourseAnnualFSMissing"
                    :nonRecourseBanksStatementMissing="nonRecourseBanksStatementMissing"
                    :nonRecourseEvidenceMissing="nonRecourseEvidenceMissing"
                    :recourseAnnualFSMissing="recourseAnnualFSMissing"
                    :recourseBankStatementMissing="recourseBankStatementMissing"
                    :supportingDocsFilesMissing="supportingDocsFilesMissing"
                    :filesNameSupporting="filesNameSupporting"
                    :filesNameAnnualFinancialStatements="filesNameAnnualFinancialStatements"
                    :filesNameBankStatement="filesNameBankStatement"
                    :filesNameInterimFinancialStatements="filesNameInterimFinancialStatements"
                    :filesNameMasterAgreement="filesNameMasterAgreement"
                    :filesNamePurchaseOrder="filesNamePurchaseOrder"
                    :filesNameDeliveryConfirmation="filesNameDeliveryConfirmation"
                    :filesNameStatementOfWork="filesNameStatementOfWork"
                    :uploadRecourseFile="uploadRecourseFile"
                    :triggerFileInput5="triggerFileInput5"
                    :triggerFileInputAFS="triggerFileInputAFS"
                    :triggerFileInputBS="triggerFileInputBS"
                    :triggerFileInputIFS="triggerFileInputIFS"
                    :triggerFileInputMA="triggerFileInputMA"
                    :triggerFileInputPO="triggerFileInputPO"
                    :triggerFileInputDC="triggerFileInputDC"
                    :triggerFileInputSOW="triggerFileInputSOW"
                    :changeInvoiceFact="changeInvoiceFact"
                    :acceptReverseChange="acceptReverseChange"
                    :acceptReverseError="acceptReverseError"
                  />
                </b-col>
              </b-row>
              <b-row v-else cols="12" xl="6" md="6" lg="6">
                <img src="/new-loader.svg" />
              </b-row>
            </div>
          </b-form>
          <hr />
        </b-col>

        <b-row class="col-md-12" v-if="uploadedInvoices.length > 0" align="end">
          <b-col class="no-padding">
            <b-button :disabled="submitButtonDisable" variant="primary" @click="submit()">{{
              $t("submit")
              }}
            </b-button>
          </b-col>
        </b-row>
      </validation-observer>

      <AddNewCompnayModal :showDialog="addNewComp" :invoice="invoice" :company="companyZefixData"
        @showSettings="showSettings" @closeAddCompModal="closeAddCompModal"></AddNewCompnayModal>
      <MainContactModal :showDialog="MainContact" :invoice="invoice" :company="companyZefixDataMainContact"
        @showSettings="showSettings" @closeMainContactModal="closeMainContactModal"></MainContactModal>
    </b-row>
  </b-card>
</template>
<script>
import { ValidationObserver, ValidationProvider } from "vee-validate";
import AddNewCompnayModal from "../cookpit/AddNewCompanyModal.vue";
import { VueAutosuggest } from "vue-autosuggest";
import Cleave from "vue-cleave-component";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import MainContactModal from "./MainContactModal.vue";
import i18n from "@/libs/i18n";

export default {
  data() {
    return {
      autoRemoveTimeValue: Number(
        (this.$store.state.auth.user && this.$store.state.auth.user.auto_remove_days) || 7
      ),
      autoRemoveDaysError: "",
      submitButtonDisable: false,
      additionalDocsUploaded: false,
      silent_factoring_accepted: true,
      filesMissing: false,
      nonRecourseAnnualFSMissing: false,
      nonRecourseBanksStatementMissing: false,
      nonRecourseEvidenceMissing: false,
      recourseAnnualFSMissing: false,
      recourseBankStatementMissing: false,
      additionalDocsFilesMissing: false,
      supportingDocsFilesMissing: false,
      openModal: false,
      companyZefixData: null,
      file1: null,
      selectedFile: null,
      eventFile: null,
      singleFile: null,
      showDetails: false,
      load: false,
      myComp: "",
      company_id: this.$store.state.auth.user.company_id,
      debtor: null,
      selected: "",
      payment_date: "",
      issue_date: "",
      due_date: "",
      recourse: 1,
      invoice_num: Number,
      filteredOptions: [],
      MainContact: false,
      companyZefixDataMainContact: null,
      maxDays: 90,
      amount: Number,
      acceptReverseError: true,
      acceptReverse: false,
      companies: [
        {
          text: "Please select an option",
          value: null,
        },
      ],
      disableInputs: false,
      addNew: false,
      uploadedInvoices: [],
      invoice: null,
      parsedDate: "",
      valid: false,
      addNewComp: false,
      selectedIndex: 0,
      successMessage: false,
      timeout: null,
      formatDateInput: "",
      recourseOptions: [
        {
          value: 0,
          name: i18n.t("Non-Recourse"),
          title: 'non_recourse_tooltip_title'
        },
        {
          value: 1,
          name: i18n.t("Recourse"),
          title: 'recourse_tooltip_title'
        },
        {
          value: 2,
          name: i18n.t("Reverse"),
          title: 'reverse_tooltip_title'

        },
      ],
      options: {
        date: {
          date: true,
          delimiter: "/",
          datePattern: ["d", "m", "Y"],
        },
        customDelimiter: {
          delimiters: ["'", "."],
          blocks: [2, 3, 2],
          uppercase: true,
        },
      },
      phoneContries: "",
      showHint: false,
      phoneCountriesList: [],
      phoneValidation: "",
      errorDueDate: "",
      numbersAmountError: "",
      companyMessage: "",
      taskStatus: 1,
      loader: false,
      acceptRecourse: false,
      user_uploaded_analysis: [],
      documentRequestStatuses: {},
      currencies: null,
      currency_name: null,
      currency_id: null,
      currencyError: null,
      disabledDueDates: null,
      filesName: [],
      filesNameSupporting: [],
      filesNameAnnualBalance: [],
      filesNameTaxSettlement: [],
      filesNameAnnualFinancialStatements: [],
      filesNameBankStatement: [],
      filesNameInterimFinancialStatements: [],
      filesNameMasterAgreement: [],
      filesNamePurchaseOrder: [],
      filesNameDeliveryConfirmation: [],
      filesNameStatementOfWork: [],
    };
  },
  components: {
    ValidationProvider,
    ValidationObserver,
    AddNewCompnayModal,
    VueAutosuggest,
    Cleave,
    MainContactModal,
    InvoiceDocuments: () => import("./InvoiceDocuments.vue"),
  },
  computed: {
    disabledDates() {
      var date = new Date();
      var today = new Date(date.getFullYear(), date.getMonth(), date.getDate());
      this.disabledDueDates = today
      return today;
    },

  },
  mounted() {
    this.getCompanies();
    this.getUserAnalysis();
    this.getStatistics();
    this.getTasks();
  },
  created() {
    this.getCurrencies();
  },
  methods: {
    getCurrencies() {
      this.$http.post("/currency").then((response) => {
        if (response.data.status == 200) {
          this.currencies = response.data.value;
        }
      });
    },

    changeCurrency(id, name) {

      if (id) {
        this.currency_id = id;
      }

      if (name) {
        this.currency_name = name;
      }

    },

    getValidationRules(item) {
      return item.recourse != 1 ? 'required' : ''
    },

    openLink() {
      window.open("https://support-aequitex.zohobookings.eu/#/KMU", "_blank");
    },

    getUserAnalysis() {
      this.$http.post(`/user_analysis/${this.$store.state.auth.user.id}`).then((res) => {
        this.user_uploaded_analysis = (res.data.value && res.data.value.files) || {};
        this.documentRequestStatuses = (res.data.value && res.data.value.document_request_statuses) || {};
      });
    },
    hasValidPreviouslyUploaded(documentType) {
      const status = this.documentRequestStatuses[documentType];
      return !!(status && status.is_valid);
    },
    changeRecourse(item, index, value) {
      item.recourse = value;
      const i = this.uploadedInvoices[index];
      i.recourse = value
    },
    acceptReverseChange(val) {
      if (val) {
        this.acceptReverseError = false;
      }
    },
    uploadRecourseFile(event, fileType, index) {
      const files = event.target.files;
      if (fileType === 'additional_docs') {
        this.uploadedInvoices[index].additional_docs = [];
        this.filesName = [];

        for (let i = 0; i < files.length; i++) {
          this.filesName.push(files[i].name);
          this.uploadedInvoices[index].additional_docs.push(files[i]);
        }

        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$t("file_uploaded_successfully"),
            icon: "SuccessIcon",
            variant: "success",
          },
        });
      }
      if (fileType === 'supporting_docs' || fileType === 'receivable_invoices') {
        this.uploadedInvoices[index].supporting_docs = [];
        this.filesNameSupporting = [];
        for (let i = 0; i < files.length; i++) {
          this.filesNameSupporting.push(files[i].name);
          this.uploadedInvoices[index].supporting_docs.push(files[i]);
        }
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$t("file_uploaded_successfully"),
            icon: "SuccessIcon",
            variant: "success",
          },
        });
      }
      if (fileType === 'annual_balance') {
        this.uploadedInvoices[index].annual_balance = [];
        this.filesNameAnnualBalance = [];
        for (let i = 0; i < files.length; i++) {
          this.filesNameAnnualBalance.push(files[i].name);
          this.uploadedInvoices[index].annual_balance.push(files[i]);
        }
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$t("file_uploaded_successfully"),
            icon: "SuccessIcon",
            variant: "success",
          },
        });
      }
      if (fileType === 'tax_settlement') {
        this.uploadedInvoices[index].tax_settlement = [];
        this.filesNameTaxSettlement = [];
        for (let i = 0; i < files.length; i++) {
          this.filesNameTaxSettlement.push(files[i].name);
          this.uploadedInvoices[index].tax_settlement.push(files[i]);
        }
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$t("file_uploaded_successfully"),
            icon: "SuccessIcon",
            variant: "success",
          },
        });
      }
      if (fileType === 'annual_financial_statements') {
        this.uploadedInvoices[index].annual_financial_statements = [];
        this.filesNameAnnualFinancialStatements = [];
        for (let i = 0; i < files.length; i++) {
          this.filesNameAnnualFinancialStatements.push(files[i].name);
          this.uploadedInvoices[index].annual_financial_statements.push(files[i]);
        }
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$t("file_uploaded_successfully"),
            icon: "SuccessIcon",
            variant: "success",
          },
        });
      }
      if (fileType === 'bank_statement') {
        this.uploadedInvoices[index].bank_statement = this.uploadedInvoices[index].bank_statement || [];
        this.filesNameBankStatement = this.filesNameBankStatement || [];
        for (let i = 0; i < files.length; i++) {
          this.filesNameBankStatement.push(files[i].name);
          this.uploadedInvoices[index].bank_statement.push(files[i]);
        }
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$t("file_uploaded_successfully"),
            icon: "SuccessIcon",
            variant: "success",
          },
        });
      }
      if (fileType === 'interim_financial_statements') {
        this.uploadedInvoices[index].interim_financial_statements = [];
        this.filesNameInterimFinancialStatements = [];
        for (let i = 0; i < files.length; i++) {
          this.filesNameInterimFinancialStatements.push(files[i].name);
          this.uploadedInvoices[index].interim_financial_statements.push(files[i]);
        }
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$t("file_uploaded_successfully"),
            icon: "SuccessIcon",
            variant: "success",
          },
        });
      }
      if (fileType === 'master_agreement') {
        this.uploadedInvoices[index].master_agreement = [];
        this.filesNameMasterAgreement = [];
        for (let i = 0; i < files.length; i++) {
          this.filesNameMasterAgreement.push(files[i].name);
          this.uploadedInvoices[index].master_agreement.push(files[i]);
        }
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$t("file_uploaded_successfully"),
            icon: "SuccessIcon",
            variant: "success",
          },
        });
      }
      if (fileType === 'purchase_order') {
        this.uploadedInvoices[index].purchase_order = [];
        this.filesNamePurchaseOrder = [];
        for (let i = 0; i < files.length; i++) {
          this.filesNamePurchaseOrder.push(files[i].name);
          this.uploadedInvoices[index].purchase_order.push(files[i]);
        }
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$t("file_uploaded_successfully"),
            icon: "SuccessIcon",
            variant: "success",
          },
        });
      }
      if (fileType === 'delivery_confirmation') {
        this.uploadedInvoices[index].delivery_confirmation = [];
        this.filesNameDeliveryConfirmation = [];
        for (let i = 0; i < files.length; i++) {
          this.filesNameDeliveryConfirmation.push(files[i].name);
          this.uploadedInvoices[index].delivery_confirmation.push(files[i]);
        }
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$t("file_uploaded_successfully"),
            icon: "SuccessIcon",
            variant: "success",
          },
        });
      }
      if (fileType === 'statement_of_work') {
        this.uploadedInvoices[index].statement_of_work = [];
        this.filesNameStatementOfWork = [];
        for (let i = 0; i < files.length; i++) {
          this.filesNameStatementOfWork.push(files[i].name);
          this.uploadedInvoices[index].statement_of_work.push(files[i]);
        }
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$t("file_uploaded_successfully"),
            icon: "SuccessIcon",
            variant: "success",
          },
        });
      }
    },
    triggerFileInput1(index) {
      document.getElementById('fileInput1' + index).click();
    },
    triggerFileInput2(index) {
      document.getElementById('fileInput2' + index).click();
    },
    triggerFileInput3(index) {
      document.getElementById('fileInput3' + index).click();
    },
    triggerFileInput4() {
      document.getElementById('fileInput4').click();
    },
    triggerFileInput5() {
      document.getElementById('fileInput5').click();
    },
    triggerFileInputAFS(index) {
      document.getElementById('fileInputAFS' + index).click();
    },
    triggerFileInputBS(index) {
      document.getElementById('fileInputBS' + index).click();
    },
    triggerFileInputIFS(index) {
      document.getElementById('fileInputIFS' + index).click();
    },
    triggerFileInputMA(index) {
      document.getElementById('fileInputMA' + index).click();
    },
    triggerFileInputPO(index) {
      document.getElementById('fileInputPO' + index).click();
    },
    triggerFileInputDC(index) {
      document.getElementById('fileInputDC' + index).click();
    },
    triggerFileInputSOW(index) {
      document.getElementById('fileInputSOW' + index).click();
    },
    changeInvoiceFact(value, index) {
      const item = this.uploadedInvoices[index];
      const hasAnnualFS = (item.annual_financial_statements && item.annual_financial_statements.length > 0) || (item.annual_balance && item.annual_balance.length > 0);
      const hasBankStatement = (item.bank_statement && item.bank_statement.length > 0) || (item.tax_settlement && item.tax_settlement.length > 0);
      const hasValidAnnualFS = this.hasValidPreviouslyUploaded('annual_financial_statements');
      const hasValidBankStatement = this.hasValidPreviouslyUploaded('bank_statement');
      const canUseAnnualFS = hasAnnualFS || hasValidAnnualFS;
      const canUseBankStatement = hasBankStatement || hasValidBankStatement;

      if (canUseAnnualFS && canUseBankStatement) {
        item.accept_recourse = true;
        this.filesMissing = false;
        this.recourseAnnualFSMissing = false;
        this.recourseBankStatementMissing = false;
      } else {
        item.accept_recourse = '';
        this.filesMissing = true;
        if (!canUseAnnualFS) {
          this.recourseAnnualFSMissing = true;
        }
        if (!canUseBankStatement) {
          this.recourseBankStatementMissing = true;
        }
        return;
      }
    },
    getTasks() {
      this.$http.post("/company/tasks").then((res) => {
        this.taskStatus = res.data.value[1].status;
      });
    },
    parsedAmount1($event, val, index) {
      this.numbersAmountError = "";
      let regex = /^[0-9']*(.)?[0-9]*$/;

      if (regex.test(val)) {
        setTimeout(() => {
          if (val) {
            if (val.includes("'") || val.includes("'")) {
              val = val.replace(/'/gi, "");
              val = val.replace(/'/gi, "");
            }
            val = Number(val)
              .toFixed(2)
              .replace(/\d(?=(\d{3})+\.)/g, "$&'");
          }
          document.getElementById(
            this.$t("invoice_amount") + " " + index
          ).value = val;

          this.uploadedInvoices[index].amount = val;
        }, 1500);
      }
    },
    parsedAmount(val, index) {
      setTimeout(() => {
        if (val) {
          if (val.includes("'")) {
            val = val.replace(/'/gi, "");
          }
          val = Number(val)
            .toFixed(2)
            .replace(/\d(?=(\d{3})+\.)/g, "$&'");
        }

        document.getElementById("Invoice Amount " + index).value = val;
      }, 1000);
    },
    async onSelected(val, item, index) {
      this.loader = true;
      item.company_name = val.item;
      await this.getCompanyDataFromZefix(item, index);
    },

    async getCompanyDataFromZefix(item, index) {
      if (typeof this.companies[item.company_name] !== "undefined" || item.company_name) {
        try {
          const zefixSearch = this.companies[item.company_name];
          let zefixDetails = null;

          if (zefixSearch) {
            const res = await this.$http.post("/get-company-data-from-zefix", {
              search: zefixSearch,
            });
            if (res) {
              zefixDetails = res.data.value;
            }
          }

          item.company_uid = zefixDetails?.uid || zefixSearch || "";
          let data = {
            search: item.company_uid || zefixSearch || "",
            invoice_id: item.id,
            company_name: item.company_name,
            zip: zefixDetails?.address?.swissZipCode || zefixDetails?.zip || "",
            company_city: zefixDetails?.address?.city || zefixDetails?.city || "",
          };
          this.addNewComp = false;
          this.MainContact = false;

          const res2 = await this.$http.post("/invoice/getCompany", data);
          if (res2) {
            this.loader = false;

            if (res2.data.value && res2.data.value.from === "Database") {
              item.issuer_id = res2.data.value.company.id;
            } else if (
              res2.data.value &&
              res2.data.value.from === "ContactPerson"
            ) {
              this.showMainContactModal(item, index, res2.data.value.company);
            } else {
              this.showModal(item, index, res2.data.value.company);
            }
          }
        } catch (error) {
          console.error(error);
        }
      }
    },
    searchForCompaniesName(item) {
      clearTimeout(this.timeout);
      clearTimeout(this.timeout);
      this.companyMessage = "";
      const self = this;
      this.timeout = setTimeout(function () {
        if (item.company_name.length > 2) {
          self.showHint = true;
          self.companies = [];
          self.filteredOptions = [];
          self.$http
            .post("/get-companies-name-from-zefix", {
              search: item.company_name,
            })
            .then((res) => {
              let obj = res.data.value;
              let myArray = [];
              for (var prop in obj) {
                if (obj[prop] != self.myComp.uid) {
                  myArray.push(prop);
                }
              }
              self.successMessage = false;
              self.showHint = false;
              self.filteredOptions.push({
                data: myArray,
              });
              self.companies = res.data.value;
              if (res.data.value.length < 1) {
                self.companyMessage = true;
              }
            });
        } else {
          self.companies = [];
          self.showHint = false;
          self.filteredOptions = [];
        }
      }, 1000);
    },

    selectIssuerValue(item) {
      item = this.companies[0].issuer_id;
      return item;
    },
    getStatistics() {
      this.$http
        .post(`/company/show/${this.$store.state.auth.user.company_id}`)
        .then((res) => {
          if (res) {
            this.myComp = res.data.value;
          }
        });
    },
    showSettings() {
      this.addNewComp = false;
      this.openModal = false;
    },
    closeMainContactModal(data) {
      if (data != null) {
        this.uploadedInvoices[this.selectedIndex].issuer_id =
          data[0].company_id;
      } else {
        this.uploadedInvoices[this.selectedIndex].company_name = "";
      }

      this.$bvModal.hide("MainContact");
    },
    closeAddCompModal(data) {
      if (data != null) {
        this.uploadedInvoices[this.selectedIndex].company_name = data[0].name;
        this.uploadedInvoices[this.selectedIndex].uid = data[0].uid;
        this.uploadedInvoices[this.selectedIndex].issuer_id = data[0].id;
      } else {
        this.uploadedInvoices[this.selectedIndex].company_name = "";
      }
      this.$bvModal.hide("AddCompany");
    },
    showModal(item, index, company) {
      this.addNewComp = true;
      this.MainContact = false;
      this.companyZefixData = company;
      this.invoice = item;
      this.selectedIndex = index;
      this.$nextTick(() => {

        this.$bvModal.show("AddCompany");
      });

    },
    showMainContactModal(item, index, company) {
      this.addNewComp = false;
      this.MainContact = true;
      this.companyZefixDataMainContact = company;
      this.invoice = item;
      this.selectedIndex = index;

      this.$nextTick(() => {
        this.$bvModal.show("MainContact");
      });

    },

    uploadFile(event, file) {
      this.eventFile = event;
      let config = { headers: { "Content-Type": "multipart/form-data" } };
      let formData = new FormData();

      if (event.target.files.length < 1) {
        return ''
      }

      event.target.files.forEach((el, index) => {
        formData.append("file" + index, el);
      });
      formData.append("length", event.target.files.length);
      this.$http.post(`/invoice/storeFiles`, formData, config).then((res) => {
        if (res.data.status == 200) {
          this.uploadedInvoices = res.data.value;
          this.uploadedInvoices = res.data.value.map((item) => {
            return {
              ...item,
              recourse: 0,
              amount: null,
              accept_recourse: false,
              tax_settlement: null,
              annual_balance: null,
              additional_docs: null,
              annual_financial_statements: null,
              bank_statement: null,
              interim_financial_statements: null,
              master_agreement: null,
              purchase_order: null,
              delivery_confirmation: null,
              statement_of_work: null,
              auto_remove_days: null,
              due_days_calculated: null
            };
          }).filter(Boolean);

        } else {
          let text = this.$t(res.data.message);
          this.$swal({
            position: "center",
            icon: "error",
            title: text,
            showConfirmButton: false,
            timer: 1500,
            customClass: {
              confirmButton: "btn btn-secondary",
            },
            buttonsStyling: false,
          });
        }
      });
    },
    async submit() {

      this.submitButtonDisable = true

      let isValid = true;
      this.autoRemoveDaysError = "";
      this.currencyError = '';
      this.nonRecourseAnnualFSMissing = false;
      this.nonRecourseBanksStatementMissing = false;
      this.nonRecourseEvidenceMissing = false;
      this.recourseAnnualFSMissing = false;
      this.recourseBankStatementMissing = false;
      this.additionalDocsFilesMissing = false;
      this.supportingDocsFilesMissing = false;

      this.uploadedInvoices.forEach((el) => {
        if ((el.recourse == 1 && !el.accept_recourse) || (el.recourse == 2 && !el.acceptReverse)) {
          el.accept_recourse = "";
          this.$refs.uploadInvoices.validate();
          isValid = false;
        }

        if (el.recourse == 1 || el.recourse == 2) {
          const hasAnnualFS = (el.annual_financial_statements && el.annual_financial_statements.length > 0) || (el.annual_balance && el.annual_balance.length > 0);
          const hasBankStatement = (el.bank_statement && el.bank_statement.length > 0) || (el.tax_settlement && el.tax_settlement.length > 0);
          const hasValidAnnualFS = this.hasValidPreviouslyUploaded('annual_financial_statements');
          const hasValidBankStatement = this.hasValidPreviouslyUploaded('bank_statement');

          if (!hasAnnualFS && !hasValidAnnualFS) {
              this.recourseAnnualFSMissing = true;
              isValid = false;
            }

          if (!hasBankStatement && !hasValidBankStatement) {
            this.recourseBankStatementMissing = true;
            isValid = false;
          }
        }

        if (el.recourse == 0) {
          const hasAnnualFS = el.annual_financial_statements && el.annual_financial_statements.length > 0;
          const hasBankStatement = el.bank_statement && el.bank_statement.length > 0;
          const hasValidAnnualFS = this.hasValidPreviouslyUploaded('annual_financial_statements');
          const hasValidBankStatement = this.hasValidPreviouslyUploaded('bank_statement');

          if (!hasAnnualFS && !hasValidAnnualFS) {
            this.nonRecourseAnnualFSMissing = true;
            isValid = false;
          }

          if (!hasBankStatement && !hasValidBankStatement) {
            this.nonRecourseBanksStatementMissing = true;
            isValid = false;
          }

          const hasEvidence =
            (el.master_agreement && el.master_agreement.length > 0) ||
            (el.purchase_order && el.purchase_order.length > 0) ||
            (el.delivery_confirmation && el.delivery_confirmation.length > 0) ||
            (el.statement_of_work && el.statement_of_work.length > 0);

          if (!hasEvidence) {
            this.nonRecourseEvidenceMissing = true;
            isValid = false;
          }
        }
      });

      const formValidation = await this.$refs.uploadInvoices.validate();
      if (this.errorDueDate.length > 1) {
        this.$refs.formValidate.validate();
        isValid = false;
      }
      if (!this.currency_id) {
        this.currencyError = 'The Currency 0 field is required';
        isValid = false;
      }
      const isAutoRemoveDaysEmpty =
        this.autoRemoveTimeValue === null ||
        this.autoRemoveTimeValue === "" ||
        typeof this.autoRemoveTimeValue === "undefined" ||
        Number.isNaN(this.autoRemoveTimeValue);

      if (isAutoRemoveDaysEmpty) {
        this.autoRemoveDaysError = "set_invoice_auto_remove_days_error";
        isValid = false;
      }

      if (isValid == false || !formValidation) {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        this.submitButtonDisable = false
        return
      }

      if (isValid && formValidation && this.numbersAmountError.length < 1 && this.currency_id) {

        const formData = new FormData();

        this.uploadedInvoices.forEach((el, index) => {
          formData.append(`invoices[${index}][id]`, el.id);
          formData.append(`invoices[${index}][recourse]`, el.recourse);
          formData.append(`invoices[${index}][accept_recourse]`, el.accept_recourse);
          formData.append(`invoices[${index}][amount]`, el.amount.replace(/'/g, ""));
          formData.append(`invoices[${index}][company_name]`, el.company_name);
          formData.append(`invoices[${index}][issue_date]`, el.issue_date);
          formData.append(`invoices[${index}][terms]`, el.terms);
          formData.append(`invoices[${index}][due_date]`, el.due_date);
          formData.append(`invoices[${index}][invoice_number]`, el.invoice_number);
          formData.append(`invoices[${index}][partial_purchase]`, el.partial_purchase || '');
          formData.append(`invoices[${index}][auto_remove_days]`, this.autoRemoveTimeValue || 0);

          const fileFields = [
            { key: 'annual_balance', formKey: 'annual_balance' },
            { key: 'tax_settlement', formKey: 'tax_settlement' },
            { key: 'additional_docs', formKey: 'additional_docs' },
            { key: 'supporting_docs', formKey: 'supporting_docs' },
            { key: 'annual_financial_statements', formKey: 'annual_financial_statements' },
            { key: 'bank_statement', formKey: 'bank_statement' },
            { key: 'interim_financial_statements', formKey: 'interim_financial_statements' },
            { key: 'master_agreement', formKey: 'master_agreement' },
            { key: 'purchase_order', formKey: 'purchase_order' },
            { key: 'delivery_confirmation', formKey: 'delivery_confirmation' },
            { key: 'statement_of_work', formKey: 'statement_of_work' },
          ];

          fileFields.forEach(({ key, formKey }) => {
            if (el[key] && el[key].length > 0) {
              // Use for loop for better performance with large arrays
              for (let fileIndex = 0; fileIndex < el[key].length; fileIndex++) {
                formData.append(`invoices[${index}][${formKey}][${fileIndex}]`, el[key][fileIndex]);
              }
            }
          });

          formData.append(`invoices[${index}][currency_id]`, this.currency_id);

        });

        let config = { headers: { "Content-Type": "multipart/form-data" } };

        this.$http
          .post(`/invoice/storeMultipleData`, formData, config)
          .then((res) => {
            if (res) {
              if (res.data.status == 200) {
                this.submitButtonDisable = false
                this.showSuccessMessage(res.data.value[0].id);
              } else {
                this.$swal({
                  position: "center",
                  icon: "error",
                  title: this.$t(res.data.message),
                  showConfirmButton: false,
                  timer: 1500,
                  customClass: {
                    confirmButton: "btn btn-primary",
                  },
                  buttonsStyling: false,
                });
              }
            }
          });
      }
    },
    removeItem(item, index) {
      this.$http.post(`/invoice/delete/${item.id}`).then((res) => {
        if (res) {
          this.uploadedInvoices.splice(index, 1);
        }
      });
    },
    showSuccessMessage(invoice_id = null) {
      let text = this.$t("invoice_information_saved_successfully");
      this.$swal({
        position: "center",
        icon: "success",
        title: text,
        showConfirmButton: false,
        timer: 1500,
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      }).then((res) => {
        const redirectUrl = invoice_id ? `/invoice/${invoice_id}` : '/invoices';
        this.$router.push(redirectUrl);
      });
    },
    getCompanies() {
      this.$http
        .post("/company/admin/list?")
        .then((response) => {
          if (response.data.status == 200) {
            this.addNewComp = false;
            this.companies = response.data.value.data;

            this.companies.forEach((el) => {
              if (el.id > el.id + 1) {
                this.selected = el;
              }

              if (el.uid == this.myComp.uid) {
                el.disabled = true;
              }
            });
          }
        })
        .catch((error) => {
        });
    },
    calculateDueDays(item, index) {
      if (item.due_date) {
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        const dueDate = new Date(item.due_date);
        dueDate.setHours(0, 0, 0, 0);
        const differenceInTime = dueDate.getTime() - today.getTime();
        const differenceInDays = Math.ceil(differenceInTime / (1000 * 3600 * 24));
        const dueDays = differenceInDays >= 0 ? differenceInDays : 0;
        item.due_days_calculated = dueDays;
        let input = document.getElementById("due_days_calculated_" + index);
        if (input) {
          input.value = dueDays;
        }
      } else {
        item.due_days_calculated = null;
      }
    },

    changeTerms(item, index) {
      if (item.issue_date && item.due_date) {
        let compareDate = "";
        const startDate = new Date(item.issue_date);
        const endDate = new Date(item.due_date);
        const differenceInTime = endDate.getTime() - startDate.getTime();
        const differenceInDays = differenceInTime / (1000 * 3600 * 24);
        let term = Math.abs(Math.round(differenceInDays));
        this.errorDueDate = "";
        this.disabledSumbit = false;
        let input = document.getElementById("payment_term_in_days_" + index);
        input.value = term;
        item.terms = term;
      } else if (item.issue_date && !item.due_date) {
        const startDate = new Date(item.issue_date);
        this.disabledDueDates = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate() + 1)
      }

      this.calculateDueDays(item, index);
    },
    changeDueDate(item, index) {
      this.errorDueDate = "";
      if (Number(item.terms) > 120) {
        this.errorDueDate = this.$t("max_allowed_days_is_120");
        return;
      }

      if (item.length > 1) {
        item = 90;
      }
      let input = document.getElementById("due_date" + index + "__value_");

      if (item.issue_date && item.terms) {
        let newDate = new Date(item.issue_date);
        let term = Number(item.terms);
        let parsed = new Date(item.issue_date);
        let compareDate = "";
        newDate.setDate(parsed.getDate() + term);
        compareDate = newDate;
        let lang = "en-us";
        if (this.$store.state.app.language == "de") {
          lang = "de-de";
        }
        input.innerText = newDate.toLocaleDateString(lang, {
          weekday: "long",
          year: "numeric",
          month: "long",
          day: "numeric",
        });
        item.due_date = newDate.toISOString().split("T")[0];
        let max = 0;
        if (term <= 30) {
          max = 10;
        } else if (term <= 45) {
          max = 12;
        } else if (term <= 60) {
          max = 15;
        } else if (term <= 75) {
          max = 17;
        } else if (term > 75) {
          max = 20;
        }
        compareDate.setDate(compareDate.getDate() - max);
        var today = new Date();
      }
    },
    triggerFileInput() {
      this.$refs.fileInput1.$refs.input.click();
    },
  },
};
</script>
<style scoped>
.asterik-size {
  font-size: 16px;
}
</style>
